import angular from 'angular';
import uiRouter from 'angular-ui-router';
import loansDetailFinishDeadlineComponent from './loansDetailFinishDeadline.component';

let loansDetailFinishDeadlineModule = angular.module('loansDetailFinishDeadline', [
  uiRouter
])

.component('loansDetailFinishDeadline', loansDetailFinishDeadlineComponent)

.name;

export default loansDetailFinishDeadlineModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansDetail/loansDetailFinishDeadline/loansDetailFinishDeadline.js